export default "__VITE_ASSET__CMUa3POS__"